export const categories = [
  {
    slug: 'brand-story',
    name: '品牌故事',
    description: '追溯高柳家的起源与传承，了解家族世代相传的精神内核与文化积淀。',
    icon: 'ri-book-open-line',
    image: 'https://readdy.ai/api/search-image?query=Traditional%20Japanese%20family%20heirloom%20objects%20displayed%20on%20wooden%20shelf%20with%20warm%20ambient%20lighting%2C%20antique%20ceramics%20and%20calligraphy%20scrolls%2C%20tatami%20room%20background%2C%20soft%20natural%20light%20from%20shoji%20screen%2C%20elegant%20minimalist%20composition&width=800&height=500&seq=cat-brand-story&orientation=landscape',
  },
  {
    slug: 'craftsmanship',
    name: '匠心工艺',
    description: '探索高柳家代代相传的精湛技艺，感受手工艺人对完美的不懈追求。',
    icon: 'ri-hammer-line',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20artisan%20hands%20carefully%20working%20on%20traditional%20woodcraft%20in%20a%20sunlit%20workshop%2C%20wood%20shavings%20on%20workbench%2C%20traditional%20Japanese%20tools%2C%20warm%20natural%20lighting%2C%20authentic%20craftsmanship%20scene%2C%20shallow%20depth%20of%20field&width=800&height=500&seq=cat-craftsmanship&orientation=landscape',
  },
  {
    slug: 'lifestyle',
    name: '生活美学',
    description: '走进高柳家倡导的生活方式，发现日常中的雅致与宁静之美。',
    icon: 'ri-leaf-line',
    image: 'https://readdy.ai/api/search-image?query=Serene%20Japanese%20tea%20ceremony%20setting%20in%20a%20traditional%20room%20overlooking%20a%20zen%20garden%2C%20matcha%20bowl%20and%20bamboo%20whisk%20on%20tatami%20mat%2C%20soft%20morning%20light%20streaming%20through%20paper%20doors%2C%20peaceful%20atmosphere%2C%20minimalist%20elegance&width=800&height=500&seq=cat-lifestyle&orientation=landscape',
  },
  {
    slug: 'cultural-heritage',
    name: '文化传承',
    description: '深入理解高柳家所守护的文化遗产，感受传统在现代社会中的生命力。',
    icon: 'ri-building-2-line',
    image: 'https://readdy.ai/api/search-image?query=Historic%20Japanese%20wooden%20architecture%20with%20sliding%20doors%20and%20engawa%20veranda%20surrounded%20by%20moss%20garden%2C%20ancient%20trees%2C%20soft%20afternoon%20sunlight%2C%20traditional%20Japanese%20estate%2C%20cultural%20heritage%20preservation%2C%20timeless%20beauty&width=800&height=500&seq=cat-culture&orientation=landscape',
  },
  {
    slug: 'products',
    name: '产品体验',
    description: '体验高柳家精心打造的产品系列，每一件都承载着家族的品质承诺。',
    icon: 'ri-gift-line',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20Japanese%20lifestyle%20products%20arranged%20on%20a%20dark%20wooden%20table%2C%20ceramic%20tea%20set%2C%20handcrafted%20textiles%2C%20incense%20holder%2C%20minimalist%20product%20photography%20with%20warm%20natural%20light%2C%20clean%20cream%20background%2C%20premium%20aesthetic&width=800&height=500&seq=cat-products&orientation=landscape',
  },
];

export const allCategorySlugs = categories.map((c) => c.slug);